module.exports = __webpack_public_path__ + "static/media/bagy5.7f1a6c8a.png";